// @flow
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import popup_screenshot from "../images/popup_screenshot.png";
import blocker_screenshot from "../images/blocker_screenshot.png";
import settings_screenshot from "../images/settings_screenshot.png";
import styled from "styled-components";

const ScreenshotImage = styled.img`
	width: 100%;
`;
const MainHeading = styled.h2`
	font-size: 45px;
	text-align: center;
`;

type Props = {};
type State = {};
class HomePage extends Component<Props, State> {
	render() {
		return (
			<div>
				<MainHeading>
					<div style={{ fontSize: "60px" }}>One Click</div>
					<div style={{ fontSize: "35px" }}>45 distraction-free minutes</div>

					<Button
						variant="contained"
						color="primary"
						href="https://chrome.google.com/webstore/detail/focus-45/efjdfkfpnffgkdgehkenoikpbadfgple"
					>
						Install Chrome Extension
					</Button>
				</MainHeading>
				<ScreenshotImage src={popup_screenshot} alt="" />

				<MainHeading>
					<div style={{ fontSize: "35px" }}>
						Temporarily unblock sites by entering a code.
					</div>
				</MainHeading>
				<ScreenshotImage src={blocker_screenshot} alt="" />

				<MainHeading>
					<div style={{ fontSize: "35px" }}>
						Customize timer duration and how long sites are unblocked.
					</div>
				</MainHeading>
				<ScreenshotImage src={settings_screenshot} alt="" />

				<MainHeading>
					<Button
						variant="contained"
						color="primary"
						href="https://chrome.google.com/webstore/detail/focus-45/efjdfkfpnffgkdgehkenoikpbadfgple"
					>
						Install Chrome Extension
					</Button>
				</MainHeading>
			</div>
		);
	}
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home.js